import { callApi } from '@/api/apibase'

export const getOrderStatusByCourseId  = function (courseId) {
    return callApi('GET', `/api/external/greencourse/GetCustomerCourseStatus?greenCourseId=${courseId}`, null)
}
